let language = {
    PURCHASE_QUANTITY_MODAL_QTY_MOQ_TIP: "The minimum order quantity is {{productMoq}}. ",
    PURCHASE_QUANTITY_MODAL_QTY_MAXLIMIT_TIP:"The maximum order quantity is {{maxLimit}}.",
    PURCHASE_QUANTITY_MODAL_OK_BTN:"OK",
    PURCHASE_QUANTITY_MODAL_CANCEL_BTN:"CANCEL"
}

export { language }